export const environmentConstants = {
	APP_ENVIRONMENT: '@@APPENV@@',
	APP_REGION: '@@APPREGION@@',
	PROD: 'production',
	DEV: 'development'
};
